import Application from "../../Application";
import FormTypesPresenter, {
  IFormTypesPresenter
} from "../../presenter/formconfiguration/FormTypesPresenter";
import GetFormTypesInteractor from "./GetFormTypesInteractor";
import GetEvaluationTypesInteractor from "../evaluation/GetEvaluationTypesInteractor";

export default class ShowFormTypesInteractor {
  private application: Application;
  private output?: IFormTypesPresenter;

  constructor(application) {
    this.application = application;
  }

  async getFormTypes() {
    return this.application.container
      .resolve<GetFormTypesInteractor>("getFormTypes")
      .execute();
  }

  async getEvaluationTypes() {
    return this.application.container
      .resolve<GetEvaluationTypesInteractor>("getEvaluationTypes")
      .execute();
  }
  execute() {
    this.output = FormTypesPresenter({
      application: this.application,
      initialState: {
        formTypes: []
      }
    });

    this.getFormTypes().then(
      (formTypes) => this.output && this.output.setFormTypes(formTypes)
    );
    this.getEvaluationTypes().then(this.output.setEvaluationTypes);

    return this.output;
  }
}
